angular.module('picmonicng').directive('plsMenu', [
  '$rootScope',
  '$timeout',
  'BrowseService',
  function ($rootScope, $timeout, BrowseService) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="more-menu" role="group" ng-transclude></div>',
      scope: {},
      controller: [
        '$rootScope',
        '$scope',
        '$state',
        '$timeout',
        function ($rootScope, $scope, $state, $timeout) {
          $scope.open = false;
          $scope.base_asset_url = $rootScope.base_asset_url;
          $scope.preventScrolling = false;
          $scope.updateBrowseMoreMenu = false;

          $scope.openMenu = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();

            if ($scope.open) {
              $scope.closeMenu();
              return;
            }

            if ($scope.inTooltip) {
              var learnHeight = $scope.element[0].offsetParent.offsetParent.clientHeight;
              var learnOffset = $scope.element[0].offsetParent.offsetTop;

              $scope.tooltipMaxHeight = learnHeight - learnOffset - 16;
            }

            $scope.addClickToClose();

            // Prevent scrolling when menu is open
            if (
              $scope.preventScrolling &&
              $rootScope.htmlClasses &&
              $rootScope.htmlClasses.indexOf('browse--open-html') === -1
            ) {
              $rootScope.htmlClasses.push('browse--open-html');
            }

            $scope.open = true;
            if ($scope.updateBrowseMoreMenu) {
              BrowseService.moreMenuOpen = $scope.open;
            }
          };

          $scope.openSubMenu = function (menu) {
            $scope.activeMenu = menu;
          };

          $scope.closeSubMenu = function () {
            delete $scope.activeMenu;
          };

          $scope.closeMenu = function ($event) {
            if ($event && angular.element($event.target).hasClass('uservoice-feedback')) {
              $timeout(function () {
                $scope.closeMenu();
              });
              return;
            }

            // Prevent scrolling when menu is open
            if (
              $scope.preventScrolling &&
              $rootScope.htmlClasses &&
              $rootScope.htmlClasses.indexOf('browse--open-html') !== -1
            ) {
              $rootScope.htmlClasses.pop('browse--open-html');
            }

            $scope.removeClickToClose();
            $scope.open = false;
            if ($scope.updateBrowseMoreMenu) {
              BrowseService.moreMenuOpen = $scope.open;
            }
            $scope.closeSubMenu();

            $timeout(function () {});
          };
        },
      ],
      link: function (scope, element, attrs) {
        if (scope.buttonText) {
          element.addClass('card-options--text');
        }
        function clickHandler(e) {
          if (
            scope.open === true &&
            element[0] != e.target &&
            !angular.element(element).has(angular.element(e.target)).length &&
            !angular.element('.md-select-menu-container').has(angular.element(e.target)).length &&
            !angular.element(e.target).hasClass('more-menu-open')
          ) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }
        }

        element.on('focusout', function (e) {
          if (
            scope.open === true &&
            element[0] != e.relatedTarget &&
            !angular.element(element).has(angular.element(e.relatedTarget)).length &&
            !angular.element('.md-select-menu-container').has(angular.element(e.relatedTarget)).length &&
            $rootScope.hasKeyboardModality
          ) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }
        });

        // On escape keypress, close menu
        element.on('keydown', function (e) {
          if (scope.open && e.keyCode == 27) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }

          // Enter on a ui-sref
          if (scope.open && e.keyCode == 13 && $rootScope.hasKeyboardModality) {
            if (angular.element(e.target).attr('ui-sref')) {
              angular.element(e.target).click();
            }
          }
        });

        scope.addClickToClose = function () {
          document.body.addEventListener('click', clickHandler, true);
        };

        scope.removeClickToClose = function () {
          document.body.removeEventListener('click', clickHandler, true);
        };

        scope.calcMaxHeight = function () {
          $timeout(function () {
            scope.maxHeight = window.innerHeight - 16;

            if (window.innerWidth <= 480) {
              scope.maxHeight -= 56;
            }
          });
        };

        if (attrs.inTooltip) {
          scope.element = element;
          scope.inTooltip = true;
        }

        angular.element(window).on('resize', scope.calcMaxHeight);

        scope.$on('$destroy', function () {
          angular.element(window).off('resize', scope.calcMaxHeight);
        });

        scope.calcMaxHeight();
      },
    };
  },
]);
